import React from 'react';
import { Users, Clock } from 'lucide-react';
import { SearchBar, matchesSearch, formatDate, getRoleBadgeClass, getStatusBadgeClass, getStatusLabel } from './shared';

export default function DownlineTab({ pending, downline, searchTerm, setSearchTerm }) {
  return (
    <div className="tab-content" data-testid="sponsor-content">
      <SearchBar value={searchTerm} onChange={setSearchTerm} placeholder="Downline durchsuchen..." />
      {pending.length > 0 && (
        <div className="section-card"><h3><Clock size={18} /> Ausstehende Freigaben ({pending.length})</h3>
          <div className="user-table-wrap"><table className="user-table"><thead><tr><th>Name</th><th>E-Mail</th><th>Benutzername</th><th>Datum</th></tr></thead><tbody>
            {pending.map(p => <tr key={p.id}><td>{p.first_name} {p.last_name}</td><td>{p.email}</td><td>{p.username}</td><td>{formatDate(p.created_at)}</td></tr>)}
          </tbody></table></div>
          <p className="hint-text">Freigaben erfolgen über den Link in der E-Mail.</p>
        </div>
      )}
      <div className="section-card"><h3><Users size={18} /> Meine Downline ({downline.length})</h3>
        {downline.filter(d => matchesSearch(d, searchTerm, ['first_name', 'last_name', 'email', 'username'])).length === 0 ? <div className="empty-state"><Users size={32} /><p>{searchTerm ? 'Keine Treffer.' : 'Noch keine Mitglieder.'}</p></div> : (
          <div className="user-table-wrap"><table className="user-table"><thead><tr><th>Name</th><th>E-Mail</th><th>Linie</th><th>Status</th><th>Datum</th></tr></thead><tbody>
            {downline.filter(d => matchesSearch(d, searchTerm, ['first_name', 'last_name', 'email', 'username'])).map(d => <tr key={d.id}><td>{d.first_name} {d.last_name}</td><td>{d.email}</td><td><span className={`role-badge ${d.direct ? 'badge-sponsor' : ''}`}>{d.direct ? 'Direkt' : 'Indirekt'}</span></td><td><span className={`status-badge ${getStatusBadgeClass(d.status)}`}>{getStatusLabel(d.status)}</span></td><td>{formatDate(d.created_at)}</td></tr>)}
          </tbody></table></div>
        )}
      </div>
    </div>
  );
}
